

// import React, { useState } from "react";
// import Foodtab from "./Foodtab.js";
// import Foodscreens from "./Foodscreens.js";
// import FoodVideosTable from "./FoodVideosTable.js";

// // Tab style function
// const tabStyle = (tabNumber, activeTab) => ({
//     padding: '10px 30px',
//     backgroundColor: activeTab === tabNumber ? 'rgb(230 109 51)' : 'transparent',
//     color: activeTab === tabNumber ? 'white' : '#555',
//     border: activeTab === tabNumber ? 'none' : '1px solid #ddd',
//     borderRadius: '10px',
//     cursor: 'pointer',
//     fontWeight: '600',
//     fontSize: '14px',
//     transition: 'all 0.3s ease',
//     marginRight: '10px',
//     boxShadow: activeTab === tabNumber ? '0 4px 10px rgba(177, 93, 214, 0.3)' : 'none',
//     outline: 'none',
//     minWidth: '100px'
// });

// const FoodVideosSuperadmin = () => {

//     const [activeTab, setActiveTab] = useState(1);


//     const [showScreenModal, setShowScreenModal] = useState(false);


//     const [screens, setScreens] = useState([]);


//     const handleSaveScreens = (updatedScreens) => {
//         console.log('Screens saved:', updatedScreens);
//         setScreens(updatedScreens);
//     };


//     const renderTabContent = () => {
//         switch (activeTab) {
//             case 1:
//                 return (
//                     <Foodscreens
//                         showScreenModal={showScreenModal}
//                         setShowScreenModal={setShowScreenModal}
//                         onSaveScreens={handleSaveScreens}
//                         addedScreens={screens}
//                     />
//                 );
//             case 2:
//                 return <FoodVideosTable />;
//             case 3:
//                 return <Foodtab />;
//             default:
//                 return (
//                     <Foodscreens
//                         showScreenModal={showScreenModal}
//                         setShowScreenModal={setShowScreenModal}
//                         onSaveScreens={handleSaveScreens}
//                         addedScreens={screens}
//                     />
//                 );
//         }
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
//                     {/* Fixed Tabs Container */}
//                     <div style={{
//                         position: 'sticky',
//                         top: 0,
//                         backgroundColor: 'white',
//                         zIndex: 100,
//                         padding: '10px 0',
//                         // borderBottom: '1px solid #e0e0e0',
//                         marginBottom: '10px'
//                     }}>
//                         <div style={{
//                             display: 'flex',
//                             flexWrap: 'wrap',
//                             gap: '5px',
//                             marginLeft: '200px'
//                         }}>
//                             <button
//                                 style={tabStyle(1, activeTab)}
//                                 onClick={() => setActiveTab(1)}
//                             >
//                                 Screen Management
//                             </button>

//                             <button
//                                 style={tabStyle(3, activeTab)}
//                                 onClick={() => setActiveTab(3)}
//                             >
//                                 Food Tab
//                             </button>
//                         </div>
//                     </div>

//                     {/* Scrollable Content */}
//                     <div className="client" style={{
//                         overflowY: "auto",
//                         height: 'calc(100vh - 150px)' // Adjust height as needed
//                     }}>
//                         {/* Tab Content */}
//                         {renderTabContent()}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FoodVideosSuperadmin;


import React, { useState } from "react";
import Foodtab from "./Foodtab.js";
import Foodscreens from "./Foodscreens.js";
import FoodVideosTable from "./FoodVideosTable.js";

const Foodaddsvideos = () => {

    // ✅ TAB STATE
    const [activeTab, setActiveTab] = useState("Create Screens");

    // ✅ SCREEN STATES (from second code)
    const [showScreenModal, setShowScreenModal] = useState(false);
    const [screens, setScreens] = useState([]);

    const handleSaveScreens = (updatedScreens) => {
        console.log("Screens saved:", updatedScreens);
        setScreens(updatedScreens);
    };

    // ✅ RENDER LOGIC (UPDATED)
    const renderComponent = () => {
        switch (activeTab) {

            case "Create Screens":
                return (
                    <Foodscreens
                        showScreenModal={showScreenModal}
                        setShowScreenModal={setShowScreenModal}
                        onSaveScreens={handleSaveScreens}
                        addedScreens={screens}
                    />
                );

            case "Screens":
                return <Foodtab />;

            default:
                return (
                    <Foodscreens
                        showScreenModal={showScreenModal}
                        setShowScreenModal={setShowScreenModal}
                        onSaveScreens={handleSaveScreens}
                        addedScreens={screens}
                    />
                );
        }
    };

    // ✅ TABS
    const tabs = [

        "Create Screens",
        "Screens",

    ];

    return (
        <div className="tabs-wrapper">

            {/* ✅ TOP TABS */}
            <div className="tabs-row">
                {tabs.map((tab) => (
                    <span
                        key={tab}
                        className={`row-tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </span>
                ))}
            </div>

            {/* ✅ SCROLLABLE CONTENT */}
            <div
                className="tabs-content"
                style={{
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    height: "calc(85vh - 120px)"
                }}
            >
                {renderComponent()}
            </div>

        </div>
    );
};

export default Foodaddsvideos;